<div class="modal-content">
  <!--Header-->
  <div class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0">
    <div class="modal-title">
      <h4 class="mb-0">Bound Book Entry Details</h4>
    </div>
    <button type="button" class="close-btn float-end" aria-label="Close" (click)="closeModalClick()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body pb-0 pt-2">
    <div class="row align-items-center mb-4 px-2">
      <div class="col-12 d-flex gap-4">
        <span><span class="bold">Firearm ID:</span>
          {{ bound_book_entry.firearm_id }}</span>
        <span><span class="bold">Firearm:</span> {{ firearm_information }}</span>
        <span><span class="bold">Serial#:</span>
          {{ bound_book_entry.a_serial_number }}</span>
      </div>
    </div>

    <!-- Boxes and Buttons Row -->
    <div class="d-flex justify-content-between px-2 mb-4">
      <!--Acquisition Information-->
      <div class="box d-flex flex-column mx-0">
        <span class="bold text-success mb-2">Acquisition Information</span>
        <div class="flex-grow-1">
          <span class="bold">Date Received:</span>
          {{ bound_book_entry.a_date_acquired | date: "MM-dd-yyyy h:mm a" }}
          <br />
          <span class="bold mt-1 d-block">Received From:</span>
          {{ bound_book_entry.a_received_from_name }}
        </div>
      </div>

      <!--Disposition Information-->
      <div class="box d-flex flex-column mx-0">
        <span class="bold mb-2" style="color:rgb(219,64,30)">Disposition Information</span>
        <div class="flex-grow-1">
          @if (!bound_book_entry.d_date_disposed) {
          <span class="text-danger">
            This Item has not been disposed yet.</span>
          }
          @if (bound_book_entry.d_date_disposed) {
          <div>
            <span class="bold">Date Disposed:</span>
            {{ bound_book_entry.d_date_disposed }}
            <br />
            <span class="bold">Form 4473#:</span>
            {{
            bound_book_entry.d_form4473_id
            ? bound_book_entry.d_form4473_id
            : "N/A"
            }}
            <br />
            <span class="bold">Disposed To:</span>
            @if (bound_book_entry?.d_first_name) {
            <span>
              {{
              bound_book_entry?.d_first_name +
              " " +
              bound_book_entry?.d_middle_name +
              " " +
              bound_book_entry?.d_last_name
              }}
            </span>
            }
            @if (bound_book_entry?.d_disposed_to) {
            <span>
              {{
              bound_book_entry?.d_business_name
              ? bound_book_entry?.d_business_name
              : bound_book_entry?.d_disposed_to
              }}
            </span>
            }
          </div>
          }
        </div>
      </div>

      <!--Button Collection-->
      <div class="button_collection d-flex flex-column gap-2 mx-0 align-items-end" style="width: auto">
        <!-- Edit -->
        <div class="btn-group w-100" dropdown>
          <button id="button-edit" dropdownToggle type="button"
            class="btn modern-btn secondary-btn dropdown-toggle w-100 text-start d-flex justify-content-between align-items-center"
            aria-controls="dropdown-edit">
            <span><i class="fa-solid fa-pen me-2"></i> Edit</span>
            <span class="caret"></span>
          </button>
          <ul id="dropdown-edit" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-edit">
            <span class="fw-bold ms-3 mb-1 text-light small">Edit Details For:</span>
            <li class="divider dropdown-divider"></li>
            <li role="menuitem" (click)="editFirearmClick()">
              <a class="dropdown-item" style="cursor: pointer">Firearm</a>
            </li>
            <li role="menuitem" (click)="editAcquisitionClick()">
              <a class="dropdown-item" style="cursor: pointer">Acquisition</a>
            </li>
            @if (bound_book_entry.d_date_disposed) {
            <li role="menuitem" (click)="editDispositionClick()">
              <a class="dropdown-item" [attr.disabled]="
                    !bound_book_entry.d_disposed_to ? true : null
                  " style="cursor: pointer">Disposition</a>
            </li>
            }
          </ul>
        </div>

        <!-- Manage -->
        <div class="btn-group w-100" dropdown>
          <button id="button-manage" dropdownToggle type="button"
            class="btn modern-btn secondary-btn dropdown-toggle w-100 text-start d-flex justify-content-between align-items-center"
            aria-controls="dropdown-manage">
            <span><i class="fa-solid fa-user-gear me-2"></i> Manage</span>
            <span class="caret"></span>
          </button>
          <ul id="dropdown-manage" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-manage">
            <span class="fw-bold ms-3 mb-1 text-light small">Manage:</span>
            <li class="divider dropdown-divider"></li>
            <li role="menuitem">
              <a class="dropdown-item" style="cursor: pointer">Attachments</a>
            </li>
          </ul>
        </div>

        <!-- Dispose -->
        @if (!bound_book_entry.d_date_disposed) {
        <div class="btn-group w-100" dropdown>
          <button id="button-dispose" dropdownToggle type="button"
            class="btn modern-btn secondary-btn dropdown-toggle w-100 text-start d-flex justify-content-between align-items-center"
            aria-controls="dropdown-dispose">
            <span><i class="fa-solid fa-book me-2"></i> Dispose</span>
            <span class="caret"></span>
          </button>
          <ul id="dropdown-dispose" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-dispose">
            <li role="menuitem">
              <a class="dropdown-item" (click)="disposeFirearm()" style="cursor: pointer">Disposed</a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" style="cursor: pointer">Lost/Stolen</a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" style="cursor: pointer">Destroyed</a>
            </li>
          </ul>
        </div>
        }

        <!-- View Form 4473 -->
        @if (
        bound_book_entry.d_date_disposed && bound_book_entry.d_form4473_id
        ) {
        <button (click)="view4473()" type="button" class="btn modern-btn secondary-btn w-100 text-start">
          <i class="fa-solid fa-eye me-2"></i> 4473
        </button>
        }

        <!-- Revert Disposition -->
        @if (bound_book_entry.d_date_disposed) {
        <button (click)="revertDispositionClick()" type="button"
          class="btn modern-btn secondary-btn w-100 text-start px-2">
          <i class="fa-solid fa-rotate-left me-1"></i> Revert Disp
        </button>
        }
      </div>
    </div>

    <!-- Notes & Logs Section -->
    <div class="row notes px-2 m-0 w-100">
      <div class="col-12 px-0">
        <!-- Notes -->
        <h6>
          <span class="badge bg-secondary" (click)="notesIsCollapsed = !notesIsCollapsed"
            [attr.aria-expanded]="!notesIsCollapsed" aria-controls="notesCollapseEvent">
            <i class="fa-solid" [ngClass]="notesIsCollapsed ? 'fa-plus' : 'fa-minus'"></i>
          </span>
          <span class="ms-2" style="cursor: pointer" (click)="notesIsCollapsed = !notesIsCollapsed">View Notes</span>
          @if (noteData.length > 0) {
          <span class="text-info ms-2">- Note Count: {{ noteData.length }}</span>
          }
        </h6>
        <div id="notesCollapseEvent" [isAnimated]="true" [collapse]="notesIsCollapsed" (expanded)="expanded()">
          <ag-grid-angular class="modern-grid mb-3" style="width: 100%; height: 100px" 
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [rowData]="noteData"
            [enableBrowserTooltips]="true"></ag-grid-angular>
        </div>

        <!-- Event Log -->
        <h6 class="mt-3">
          <span class="badge bg-secondary" (click)="historyIsCollapsed = !historyIsCollapsed"
            [attr.aria-expanded]="!historyIsCollapsed" aria-controls="collapseEvent">
            <i class="fa-solid" [ngClass]="historyIsCollapsed ? 'fa-plus' : 'fa-minus'"></i>
          </span>
          <span class="ms-2" style="cursor: pointer" (click)="historyIsCollapsed = !historyIsCollapsed">View Event
            Logs</span>
          @if (eventData.length > 0) {
          <span class="text-info ms-2">- Event Count: {{ eventData.length }}</span>
          }
        </h6>
        <div id="collapseEvent" [isAnimated]="true" [collapse]="historyIsCollapsed" (expanded)="expanded()">
          <ag-grid-angular class="modern-grid mb-3" style="width: 100%; height: 100px" 
            [columnDefs]="eventColumnDefs" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
            [rowData]="eventData" [enableBrowserTooltips]="true"></ag-grid-angular>
        </div>
      </div>
    </div>

    <!-- Footer Row -->
    <div class="d-flex justify-content-between align-items-end mt-4 px-2 pb-3">
      <div class="text-light small">
        <span class="bold">Last modified by:</span> {{ modified_by }}
        <span class="bold ms-2">at</span> {{ modified_datetime }}
      </div>
      <button type="button" class="btn modern-btn secondary-btn px-4" (click)="closeModalClick()">
        Close
      </button>
    </div>
  </div>
</div>